<template>
  <header class="navbar navbar-expand-lg navbar-dark custom-background">
    <div class="container-fluid">
      <div class="navbar-brand">
        <img src="/media/live/logo.png" alt="Corsync" class="logo" />
      </div>
      <div class="collapse navbar-collapse" id="navbar">
        <ul v-if="isAuth" class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-for="(n, idx) of nav" :key="n.name">
            <div class="custom-nav-link">
              <breeze-nav-link
                :href="route(n.url)"
                :active="route().current(n.url)"
                class="nav-link"
              >
                {{ n.name }}
              </breeze-nav-link>
              <span v-if="idx < nav.length - 1">|</span>
            </div>
          </li>
        </ul>
        <ul v-else class="navbar-nav me-auto mb-2 mb-lg-0"></ul>
        <div v-if="isAuth" class="d-flex">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item custom-question-wrapper" @click="showHelp()">
              <i class="fas fa-question-circle"></i>
            </li>
            <li class="nav-item">
              <span class="navbar-text custom-profile">|</span>
            </li>
            <li class="nav-item custom-profile-wrapper" @click="showProfile">
              <img :src="avatar" class="custom-profile-image" />
              <span class="navbar-text custom-profile me-2">{{
                fullname
              }}</span>
            </li>
            <li class="nav-item">
              <span class="navbar-text custom-profile">|</span>
            </li>
            <li class="nav-item">
              <breeze-responsive-nav-link
                href="#"
                @click="logout()"
                class="nav-link"
              >
                Log Out
              </breeze-responsive-nav-link>
            </li>
          </ul>
          <!-- <button class="btn btn-link" @click="showOverlay"> -->
          <span class="custom-version">{{ version }}</span>
          <!-- </button> -->
        </div>
        <div v-else class="d-flex"></div>
      </div>
    </div>
    <user-dialog
      id="user-modal"
      :show="actionUser"
      @close="closeModal"
      @saved="savedUser"
      @deleted="deletedUser"
    />
  </header>
  <help-dialog
    id="helpvideos-modal"
    :show="actionHelpVideos"
    @close="closeModal"
  />
  <loading v-if="actionOverlay" @cancel="hideOverlay" />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BreezeNavLink from '@/Components/Elements/NavLink'
import BreezeResponsiveNavLink from '@/Components/Elements/ResponsiveNavLink'
import UserDialog from '@/Components/Users/forms/user-dialog'
import HelpDialog from '@/Components/HelpVideos/help-videos'
import Loading from './Loading'
import globals from '@/Plugins/globals'
export default {
  name: 'nav-top',
  components: {
    BreezeNavLink,
    BreezeResponsiveNavLink,
    Loading,
    UserDialog,
    HelpDialog,
  },
  data() {
    return {
      nav: [],
      actionUser: null,
      actionHelpVideos: null,
    }
  },
  mounted() {
    this.setLoading(false)
    this.initMenu()
    this.initSocket()
  },
  computed: {
    ...mapGetters('users', ['token', 'profile', 'isAllowed']),
    ...mapGetters('global', ['isLoading']),
    version() {
      return globals.version()
    },
    isAuth() {
      let _is = false
      if (this.token !== null) {
        if (this.token !== '') {
          _is = true
        }
      }
      return _is
    },
    fullname() {
      let _name = ''
      if (this.profile) {
        _name = this.profile.name
      }
      return _name
    },
    actionOverlay() {
      return this.isLoading
    },
    avatar() {
      let _avatar = '/media/dashboard/profile.png'
      if (this.profile) {
        if (this.profile.avatar) {
          _avatar = this.profile.avatar
        }
      }
      return _avatar
    },
  },
  methods: {
    ...mapActions('users', ['setLogout', 'getUser']),
    ...mapActions('global', ['setLoading']),
    initMenu() {
      this.nav = []
      if (this.isAllowed('/dashboard')) {
        this.nav.push({ url: 'dashboard', name: 'Dashboard', icon: '' })
      }
      if (this.isAllowed('/users')) {
        this.nav.push({ url: 'users', name: 'Users', icon: '' })
      }
      if (this.isAllowed('/organizations')) {
        this.nav.push({
          url: 'organizations',
          name: 'Organizations',
          icon: '',
        })
      }
      if (this.isAllowed('/programs')) {
        this.nav.push({ url: 'programs', name: 'Programs', icon: '' })
      }
      if (this.isAllowed('/configuration')) {
        this.nav.push({ url: 'configuration', name: 'Configuration', icon: '' })
      }
    },
    initSocket() {
      window.Echo.channel('announcement').listen('PublicAnnouncement', (e) => {
        console.log(e.message)
      })
      window.Echo.private(`messages.${this.profile.id}`).listen(
        'SocketMessage',
        (e) => {
          console.log(JSON.parse(e.message))
        }
      )
      window.Echo.private(`direct.${this.profile.id}`).listenForWhisper(
        'message',
        (e) => {
          console.log(e)
        }
      )
    },
    logout() {
      this.setLogout()
      this.$inertia.post('\\logout')
    },
    showOverlay() {
      this.setLoading(true)
    },
    hideOverlay() {
      this.setLoading(false)
    },
    async showProfile() {
      await this.getUser(this.profile.id)
      this.actionUser = {
        isAdd: false,
        cameFrom: 2,
        data: null,
      }
    },
    showHelp() {
      console.log('show help')
      this.actionHelpVideos = {
        cameFrom: 1,
      }
    },
    closeModal() {
      this.actionUser = null
      this.actionHelpVideos = null
    },
    savedUser() {},
    deletedUser() {
      this.logout()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-background {
  background-color: #2e507b;
  color: rgb(255, 255, 255);
}
.logo {
  height: 32px;
  width: auto;
}
.custom-profile-wrapper {
  cursor: pointer;
  margin-left: 8px;
  :hover {
    color: rgba(255, 255, 255, 0.75);
  }
}
.custom-question-wrapper {
  cursor: pointer;
  i {
    color: rgba(255, 255, 255, 0.55);
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    padding-top: 0.7rem;
    padding-bottom: 0.5rem;
  }
  :hover {
    color: rgba(255, 255, 255, 0.75);
  }
}
.custom-profile-image {
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 10px;
  top: 5px;
}
.custom-profile {
  position: relative;
  top: 8px;
}
.custom-nav-link {
  display: inline-flex;
  span {
    padding-top: 3px;
  }
}
.custom-version {
  position: absolute;
  right: 20px;
  bottom: 0;
  font-size: 0.7em;
  color: rgba(255, 255, 255, 0.55);
}
</style>